// MARK://dhk8/pos/hooks/useActiveBranch
// Suscripción reactiva a la sucursal activa (espejo de useTenantId).
import { useSyncExternalStore } from 'react'
import { getActiveBranchId, subscribeActiveBranch } from '../lib/api.js'

export function useActiveBranchId(): string | null {
  return useSyncExternalStore(subscribeActiveBranch, getActiveBranchId, () => null)
}
